import {Routes, Route, Link} from 'react-router-dom';

export default function Contact (){

    return (
        <div id="bookingPage">
            <div className="bgOverlayWhite">
                <div className="row" id="worksHeader">
                    <div className="col-12 col-lg-7 name">
                        <div className="row">
                            <section className="wrapper">
                                {/* <Link to={"/"}> */}
                                <div className="top">CONTACT</div>
                                {/* </Link> */}
                            </section>
                        </div>
                    </div>
                    <div className="col-12 col-lg-5 nav">
                        <div className="row">
                            <div className="col-6">
                                <Link to={"/all-works"}><span>WORKS</span></Link>
                            </div>
                            {/* <div className="col-4">
                                <Link to={"/socials"}><span>SOCIALS</span></Link>
                            </div> */}
                            <div className="col-6">
                                <Link to={"/booking"}><span>BOOKING</span></Link>
                            </div>
                        </div>
                    </div>
                </div>
                <div  id="contactContent">
                    <a href="http://instagram.com/jaykurzweil" rel="noopener noreferrer" target="_blank" title="" >
                                <img alt="" 
                                    id=""
                                    src={require("./images/ig.png")}
                                    // style="max-width: 130px;" 
                                />
                            </a>
                            <a href="http://x.com/jaykurzweil" rel="noopener noreferrer" target="_blank" title="" >
                                <img alt="" 
                                    id=""
                                    src={require("./images/x.png")}
                                    // style="max-width: 130px;" 
                                />
                            </a>
                            <a href="mailto:jay@krzwlmusic.com" rel="noopener noreferrer" target="_blank" title="" >
                                <img alt="" 
                                    id=""
                                    src={require("./images/email.png")}
                                    // style="max-width: 130px;" 
                                />
                            </a>
                            <a href="sms:+13233793469?&amp;body=" rel="noopener noreferrer" target="_blank" title="" >
                                <img alt="" 
                                    id=""
                                    src={require("./images/mobile.png")}
                                    // style="max-width: 130px;" 
                                />
                            </a>
                </div>
            </div>
        </div>
    )
}